/* POSHRADS — footer.js
   Mobile footer accordions only: toggles aria-expanded on [data-footer-toggle].
   One delegated document listener, registered once, so Theme Editor section reloads need no cleanup.
   Architecture: docs/footer.md */
(() => {
  'use strict';

  if (window.poshFooterReady) return;
  window.poshFooterReady = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-footer-toggle]');
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
  });
})();
